import generativeBorderColorsDark from "../../../../src/pages/rovo-ui/generative-border/_assets/generative-border-colors-dark.png";
import generativeBorderColorsLight from "../../../../src/pages/rovo-ui/generative-border/_assets/generative-border-colors-light.png";
import generativeBorderDark from "../../../../src/pages/rovo-ui/generative-border/_assets/generative-border-dark.png";
import generativeBorderLight from "../../../../src/pages/rovo-ui/generative-border/_assets/generative-border-light.png";
import mosaicDoDark from "../../../../src/pages/rovo-ui/generative-border/_assets/mosaic-do-dark.png";
import mosaicDoLight from "../../../../src/pages/rovo-ui/generative-border/_assets/mosaic-do-light.png";
import mosaicDontDark from "../../../../src/pages/rovo-ui/generative-border/_assets/mosaic-dont-dark.png";
import mosaicDontLight from "../../../../src/pages/rovo-ui/generative-border/_assets/mosaic-dont-light.png";
import remixHoverDark from "../../../../src/pages/rovo-ui/generative-border/_assets/remix-hover-dark.png";
import remixHoverLight from "../../../../src/pages/rovo-ui/generative-border/_assets/remix-hover-light.png";
import rovoMultipleIndicatorsDark from "../../../../src/pages/rovo-ui/generative-border/_assets/rovo-multiple-indicators-dark.png";
import rovoMultipleIndicatorsLight from "../../../../src/pages/rovo-ui/generative-border/_assets/rovo-multiple-indicators-light.png";
import rovoThinkingSkeletonDark from "../../../../src/pages/rovo-ui/generative-border/_assets/rovo-thinking-skeleton-dark.png";
import rovoThinkingSkeletonLight from "../../../../src/pages/rovo-ui/generative-border/_assets/rovo-thinking-skeleton-light.png";
import * as React from 'react';
export default {
  generativeBorderColorsDark,
  generativeBorderColorsLight,
  generativeBorderDark,
  generativeBorderLight,
  mosaicDoDark,
  mosaicDoLight,
  mosaicDontDark,
  mosaicDontLight,
  remixHoverDark,
  remixHoverLight,
  rovoMultipleIndicatorsDark,
  rovoMultipleIndicatorsLight,
  rovoThinkingSkeletonDark,
  rovoThinkingSkeletonLight,
  React
};